export default __webpack_public_path__ + "static/media/logo_couleur.12285f28.jpg";